/*
 * @Author: cdwangdongwu
 * @Date:   2017-08-23 10:09:04
 * @Last Modified by:   cdwangdongwu
 * @Last Modified time: 2017-10-23 17:12:05
 */
import querystring from 'querystring'
import Url from 'url'
import moment from 'moment'
import axios from 'axios'
import $ from 'jquery'
import Cookies from 'js-cookie'
import i18n from './i18n'
import { getSite } from '@/utils/site'
import { SLD } from '@/utils/INTERFACE'
/**
 * 获取url参数值
 * @param {string} url 需要获取参数的url
 * @param {string} name 需要获取的参数名
 * @return {string} 返回获取的参数名
 */
export function getUrlParamByName(name, url) {
	return getUrlParams(url)[name]
};

/**
 * 获取一个 url 的所有参数组成的对象
 * @param {string} url 需要处理的url
 * @return {Object} 返回一个包含所有参数的 map
 */
export function getUrlParams(url = window.location.href) {
	var query = Url.parse(url).query
	return querystring.parse(query)
};
/**
 * [appendParams 根据url追加参数]
 * @param  {[String]} url   [指定的url]
 * @param  {[Object]} param [追加的参数]
 * @return {[String]}       [追加参数后的url]
 */
export function appendParams(url, param) {
	var _tmpl = '',
		_type = $.type(param),
		_param = _type == 'string' ? param : _type == 'object' ? $.param(param) : $.trim(param); // string,object , 其他类型,调用$.trim()
	if (url.indexOf('?') < 0) {
		_tmpl = url + '?' + _param;
	} else {
		var length = url.length;
		if (url.charAt(length - 1) == '&') {
			_tmpl = url + _param;
		} else {
			_tmpl = url + '&' + _param;
		}
	}
	return _tmpl;
}

export const http = {
	async get(url, data) {
		var site=getSite()
		Cookies.set('site', site, { domain: SLD().cookieBase })
		var res = await axios.get(url, { params: data })
		if (!res.data) throw new Error("No data")
		if (res.data.result === false) {
			var err = new Error(res.data.message)
			if (res.data.messages) err.messages = res.data.messages
			throw err
		}
		return res.data
	},
	async post(url, data) {
		var res = await axios.post(url, querystring.stringify(data), {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded',
				'csrf-token': $('#csrf-token').length > 0 && $('#csrf-token').val() || ''
			}
		})
		if (res.data['csrf-token']) {
			$('#csrf-token').val(res.data['csrf-token']);
		}
		if (!res.data) throw new Error("No data")
		if (res.data.result === false) {
			var err = new Error(res.data.message)
			if (res.data.messages) err.messages = res.data.messages
			throw err
		}
		return res.data
	},
	jsonp: {
		get(url, data) {
			return new Promise((resolve, reject) => {
				$.ajax({ type: "get", dataType: "jsonp", url, data, success: resolve, error: (XMLHttpRequest, textStatus, errorThrown) => reject(textStatus) })
			})
		}
	}
}

export function formatTime(t, format) {
	var timeOffset = parseInt($("body>#offset").val())
	var limit = timeOffset ? (new Date().getTimezoneOffset() * 60000 + timeOffset) : 0
	return moment(t).add(limit, 'milliseconds').format(format || "YYYY-MM-DD HH:mm:ss")
}

export function scopeCss(css, parent) {
	if (!css) return css;
	if (!parent) return css;

	function replace(css, replacer) {
		css = css.replace(/\/\*([\s\S]*?)\*\//g, '');
		return css.replace(/([^\r\n,{}]+)(,(?=[^}]*{)|\s*{)/g, replacer);
	}
	css = replace(css, parent + ' $1$2');
	//regexp.escape
	let parentRe = parent.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	//replace self-selectors
	css = css.replace(new RegExp('(' + parentRe + ')\\s*\\1(?=[\\s\\r\\n,{])', 'g'), '$1');
	//replace `:host` with parent
	css = css.replace(new RegExp('(' + parentRe + ')\\s*:host', 'g'), '$1');
	//revoke wrongly replaced @ statements, like @supports, @import, @media etc.
	css = css.replace(new RegExp('(' + parentRe + ')\\s*@', 'g'), '@');
	css = css.replace(new RegExp('(' + parentRe + ')\\s*(to|from|\\d+%)', 'g'), '$2');
	return css;
}

/**
 * 获取颜色值转换为rgba
 * @param {string} color 颜色值16进制
 * @return {string} opactiy 透明度，默认为1
 */
export function colorToRgba(color, opactiy) {
	if (!color) return;
	let sColor = color.toLowerCase(),
		sOpactiy = opactiy || 1,
		colorReg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
	// 如果是16进制颜色
	if (sColor && colorReg.test(sColor)) {
		if (sColor.length === 4) {
			let sColorNew = "#";
			for (let i = 1; i < 4; i += 1) {
				sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
			}
			sColor = sColorNew;
		}
		//处理六位的颜色值
		let sColorChange = [];
		for (let i = 1; i < 7; i += 2) {
			sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
		}
		return "rgba(" + sColorChange.join(",") + "," + sOpactiy + ")";
	}
}

export function formatPrice(num) {
	if (!num || parseInt(num) < 0) return ''
	var str = parseInt(num) + ""
	var arr = []
	for (var i = 0; i < str.length; i = i + 3) {
		arr.unshift(str.substring(str.length - i - 3, str.length - i))
	}
	var end = " บาท"
	var language = Cookies.get('language')
	if (language == 'zh_CN' || language == 'en_US') {
		end = " ฿"
	}
	return arr.join(",") + end
}

export function formatWords(str) {
	return str.split(/[，|,|\n]/).map(str => str.trim()).filter(it => !!it).join(',')
}

/**
 * Useage：
 * 		validate("23333","max:100","min:0")
 * 		validate(null,"required")
 * @return:
 * 		{ok:false,message:"here is error message..."}
 * 		{ok:true,message:""}
 */
export function validate(val, ...keys) {
	var rules = {
		required(v) {
			return {
				ok: v !== "" && v !== null && v !== undefined,
				message: i18n.t("输入值不可为空")
			}
		},
		number(v) {
			if (!this.required(v).ok) return this.required(v)
			return {
				ok: !isNaN(v),
				message: i18n.t("输入值必须为数字")
			}
		},
		min(v, n) {
			n = parseInt(n)
			if (!this.number(v).ok) return this.number(v)
			return {
				ok: v >= n,
				message: i18n.t("输入值必须大于{n}", { n })
			}
		},
		max(v, n) {
			n = parseInt(n)
			if (!this.number(v).ok) return this.number(v)
			return {
				ok: v <= n,
				message: i18n.t("输入值必须小于{n}", { n })
			}
		},
		notEmpty(v) {
			if (!this.required(v).ok) return this.required(v)
			return {
				ok: !!v.trim(),
				message: i18n.t("输入值不可为空")
			}
		},
		url(v) {
			if (!this.required(v).ok) return this.required(v)
			return {
				ok: /^(http:|https:)?\/\/[A-Za-z0-9-]+\.[A-Za-z0-9\.\-]+[\s\S]*$/.test(v),
				message: i18n.t("输入值必须为合法链接")
			}

		}
	}
	for (let i = 0; i < keys.length; i++) {
		let args = keys[i].split(':')
		let rule = args.shift()
		if (rules[rule]) {
			var res = rules[rule](val, ...args)
			if (!res.ok) return res
		}
	}
	return {
		ok: true,
		message: ""
	}
}
